import React from 'react';

const FaceEnrollmentPage = React.lazy(() => import('pages/FaceEnrollment/FaceEnrollmentPage'));

const faceEnrollmentRoutes = [
  {
    path: '/face-enrollment',
    exact: true,
    name: 'Duyệt mẫu khuôn mặt',
    function: 'HR_FACE_ENROLLMENT',
    requireAssigned: true,
    component: FaceEnrollmentPage,
  },
];

export default faceEnrollmentRoutes;
